import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="font-body container mx-auto px-4 py-8">
      <h1 className="text-xl font-semibold mb-4">Terms of Use</h1>
      <p>Welcome to Makerstate ("we," "us," or "our"). These Terms of Use ("Terms") govern your use of our website, applications, and related services (collectively, the "Service"). By accessing or using the Service, you agree to comply with these Terms. If you do not agree, you may not use the Service.</p>
        <br></br>
        <h2>1. Acceptance of Terms</h2>
        <p>By using the Service, you agree to these Terms and our Privacy Policy. We reserve the right to modify these Terms at any time. Any changes will be posted on the Service, and your continued use of the Service after such changes constitutes your acceptance of the revised Terms.</p>
        <br></br>
        <h2>2. Access and Use of the Service</h2>
        <h3>a. Eligibility</h3>
        <p>You must be at least 18 years old to use the Service. If you are under the age of majority in your jurisdiction, you must have the consent of a legal guardian to use the Service.</p>
        <h3>b. Personal Use</h3>
        <p>The Service is for your personal and non-commercial use only. You may not use the Service for the benefit of any third party without our prior written consent.</p>
        <h3>c. Account Registration</h3>
        <p>To access certain features of the Service, you may need to create an account. You agree to provide accurate and complete information and to update it as necessary. You are responsible for maintaining the confidentiality of your account credentials.</p>
        <br></br>
        <h2>3. Fees and Payment</h2>
        <h3>a. Subscription Services</h3>
        <p>The Service may include free and paid features. If you choose to subscribe to paid features, you agree to pay all applicable fees as specified at the time of purchase.</p>
        <h3>b. Automatic Renewal</h3>
        <p>Subscriptions will automatically renew unless canceled at least one (1) business day before the end of the current billing period. By subscribing, you authorize us to charge your payment method for recurring payments.</p>
        <h3>c. Refunds</h3>
        <p>Payments are non-refundable, except as required by applicable law or at our discretion.</p>
        <br></br>
        <h2>4. User Content</h2>
        <p>You retain ownership of any content you submit to the Service ("User Content"). By submitting User Content, you grant us a worldwide, royalty-free license to use, reproduce, modify, display, and distribute your content in connection with the Service. You represent and warrant that your User Content does not infringe any third-party rights.</p>
        <br></br>
        <h2>5. Prohibited Activities</h2>
        <ul>
            <li>Use the Service for unlawful purposes.</li>
            <li>Submit false, misleading, or infringing content.</li>
            <li>Attempt to interfere with or compromise the Service’s security or integrity.</li>
            <li>Use automated tools to scrape or access the Service without our permission.</li>
            <li>Impersonate another person or entity.</li>
        </ul>
        <br></br>
        <h2>6. Intellectual Property</h2>
        <p>All content provided through the Service, including text, graphics, and software, is owned by us or our licensors and is protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works from this content without our prior written consent.</p>
        <br></br>
        <h2>7. Termination</h2>
        <p>We may terminate or suspend your access to the Service at our discretion, without notice, for any reason, including violation of these Terms. Upon termination, your rights to use the Service will cease immediately.</p>
        <br></br>
        <h2>8. Disclaimers and Limitation of Liability</h2>
        <h3>a. Disclaimers</h3>
        <p>The Service is provided "as is" without warranties of any kind, express or implied. We do not guarantee that the Service will be uninterrupted or error-free.</p>
        <h3>b. Limitation of Liability</h3>
        <p>To the fullest extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.</p>
        <br></br>
        <h2>9. Indemnification</h2>
        <p>You agree to indemnify and hold us harmless from any claims, losses, or damages arising from your use of the Service, your User Content, or your violation of these Terms.</p>
        <br></br>
        <h2>10. Third-Party Links</h2>
        <p>The Service may include links to third-party websites. We are not responsible for the content or practices of these websites.</p>
        <br></br>
        <h2>11. Governing Law and Dispute Resolution</h2>
        <p>These Terms are governed by the laws of Delaware, without regard to conflict of laws principles. Any disputes will be resolved through binding arbitration in Delaware.</p>
        <br></br>
        <h2>12. Changes to the Service</h2>
        <p>We may modify or discontinue the Service at any time without notice. We are not liable for any changes or interruptions to the Service.</p>
        <br></br>
        <h2>13. Contact Us</h2>
        <p>For questions about these Terms, please contact us at:</p>
        <address>
            Makerstate
            Email: <a href="mailto:support@makerstate.com">support@makerstate.com</a>
        </address>

        <p><em>Last Updated: 1.12.25</em></p>
    </div>
  );
};

export default TermsOfUse;